import { NextPage } from 'next'
import { isDev } from 'app/general'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { slide as Menu } from 'react-burger-menu'
import { logout } from 'actions/user'
import { useAppDispatch } from 'reducers/storeHooks'
import { MdEvent } from "react-icons/md";
import { IconType } from 'react-icons'
import { IoMdHome } from "react-icons/io";
import { MdGroupAdd } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi";
import { RiAccountCircleFill } from "react-icons/ri";
import { MdOutlineEventNote } from "react-icons/md";
import { FaLayerGroup } from "react-icons/fa6";
import { BiSolidLike } from 'react-icons/bi'
import { IoSearch } from 'react-icons/io5'
import { onBoardingUrl } from 'helpers/general'

interface Props { }
const goToPageWhenLoggedOut = '/onboarding' //'/auth/login'
const MenuManager: NextPage<Props> = (props: Props) => {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const logoutClicked = () => {
    isDev && console.log("logout clicked")
    router.push(goToPageWhenLoggedOut)
    dispatch(logout(onBoardingUrl))
  }
  const [isOpen, setIsOpen] = useState(false)

  interface Props {
    name: string
    url: string
    Icon?: IconType
  }

  const Link: NextPage<Props> = ({ name, url, Icon }) => {
    return (
      <a
        id={name}
        onClick={() => {
          setIsOpen(false)
          if (typeof window !== 'undefined') {
            window.history.pushState({}, "", url)
          }
          router.push(url)
        }}
        style={styles.bmItem}
      >
        <>
          {Icon ? <Icon style={styles.icon} /> : null}
          {name}
        </>
      </a>
    )
  }
  return (
    <Menu
      right
      styles={styles}
      isOpen={isOpen}
      onStateChange={(state) => setIsOpen(state.isOpen)}
    >
      <Link name="Home" url="/" Icon={IoMdHome} />
      <Link name="My Profile" url="/myProfile" Icon={RiAccountCircleFill} />
      <Link name="Friends" url="/friends" Icon={HiUserGroup} />
      <Link name="Latest Events" url="/events" Icon={MdEvent} />
      <Link name="Latest Communities" url="/communities" Icon={FaLayerGroup} />
      <Link name="Liked Events" url="/myLiked" Icon={BiSolidLike} />
      <Link name="Create an Event" url="/event/create" Icon={MdOutlineEventNote} />
      <Link name="Create a Community" url="/community/create" Icon={MdGroupAdd} />
      <Link name="Search" url="/search" Icon={IoSearch} />
      <div id="logout" onClick={logoutClicked} style={styles.bmItemLogout}>
        Logout
      </div>
    </Menu>
  )
}

export default MenuManager

//THE BURGER LIBRARY REQUIRES STYLES TO BE EITHER GLOBAL OR AS A JAVASCRIPT OBJECT
var styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '40px',
    height: '24px',
    right: '24px',
    top: 'calc(var(--header-size) - 50px)',
  },
  bmBurgerBars: {
    background: 'var(--color-primary)',
    margin: '4px',
  },
  bmBurgerBarsHover: {
    background: '#a90000',
  },
  bmCrossButton: {
    marginTop: '40px',
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },
  bmMenu: {
    background: '#350F29ee',
    padding: '3.5em 1.5em 0',
    fontSize: '1.15em',
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '1.5em 0.8em',
  },
  bmItem: {
    display: 'block',
    marginBottom: '20px',
    outline: 'none',
    position: 'relative' as 'relative',
    marginLeft: 30,
  },
  bmItemLogout: {
    display: 'block',
    marginBottom: '20px',
    color: '#DD4444',
    position: 'absolute' as 'absolute',
    bottom: '30px',
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
  icon: {
    width: 20,
    height: 20,
    position: "absolute" as "absolute",
    left: -35
  }
}
